module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre5",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("To"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n  CAPTAIN JOHN HUGHES"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n  and his Texas Rangers")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("It may seem strange to you that out of all the stories I heard on the Rio Grande I should choose as first that of Buck Duane—outlaw and gunman.")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But, indeed, Ranger Coffee's story of the last of the Duanes has haunted me, and I have given full rein to imagination and have retold it in my own way. It deals with the old law—the old border days—therefore it is better first. Soon, perchance, I shall have the pleasure of writing of the border of to-day, which in Joe Sitter's laconic speech, “Shore is 'most as bad an' wild as ever!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("In the North and East there is a popular idea that the frontier of the West is a thing long past, and remembered now only in stories. As I think of this I remember Ranger Sitter when he made that remark, while he grimly stroked an unhealed bullet wound. And I remember the giant Vaughn, that typical son of stalwart Texas, sitting there quietly with bandaged head, his thoughtful eye boding ill to the outlaw who had ambushed him. Only a few months have passed since then—when I had my memorable sojourn with you—and yet, in that short time, Russell and Moore have crossed the Divide, like Rangers.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Gentlemen,—I have the honor to dedicate this book to you, and the hope that it shall fall to my lot to tell the world the truth about a strange, unique, and misunderstood body of men—the Texas Rangers—who made the great Lone Star State habitable, who never know peaceful rest and sleep, who are passing, who surely will not be forgotten and will some day come into their own.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("ZANE GREY")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbbb7026","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0